import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { BaseModal } from '../../../../common/components/BaseModal/BaseModal';
import {
    DeleteModalWrapper,
    DeleteModalHeader,
    DeleteModalClose,
    DeleteModalContent,
    WarningIcon,
    DeleteModalTitle,
    DeleteModalNote,
    DeleteModalActions,
    CancelButton,
    DeleteButton
} from './DeleteConfirmationModal.styles';
import { DeleteIcon } from '../../../../assets/icons/common/common-icons';

export const DeleteConfirmationModal = observer(({
    onCancel,
    onConfirm,
    fileName,
    fileCount = 1
}) => {
    const handleConfirm = () => {
        onConfirm();
    };

    const isMultiple = fileCount > 1;
    const pluralSuffix = isMultiple ? 's' : '';
    const thisText = isMultiple ? 'these' : 'this';

    return ReactDOM.createPortal(
        <BaseModal width="600px" height="auto" borderRadius={12} onBackDropClick={onCancel}>
            <DeleteModalWrapper>
                <DeleteModalHeader>
                    <DeleteModalClose onClick={onCancel}>
                        ×
                    </DeleteModalClose>
                </DeleteModalHeader>

                <DeleteModalContent>
                    <WarningIcon>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2L22 20H2L12 2Z" fill="#E53E3E" />
                            <path d="M12 9V13" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            <path d="M12 17H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </WarningIcon>

                    <DeleteModalTitle>
                        {`Are you sure you want to delete ${thisText} file${pluralSuffix}?`}
                    </DeleteModalTitle>

                    <DeleteModalNote>
                        <div>You are about to delete {isMultiple ? <span><strong>{fileCount} files</strong>.</span> : 'the file:'}</div>
                        {!isMultiple && <div><strong>{fileName}</strong></div>}
                        <div>This will remove it from all places in Vyzer — including the Vault and any linked items.</div>
                        <div>This action cannot be undone.</div>
                    </DeleteModalNote>
                </DeleteModalContent>

                <DeleteModalActions>
                    <CancelButton onClick={onCancel}>
                        Cancel
                    </CancelButton>
                    <DeleteButton onClick={handleConfirm}>
                        <DeleteIcon />
                        {isMultiple ? `Delete ${fileCount} files` : `Delete file`}
                    </DeleteButton>
                </DeleteModalActions>
            </DeleteModalWrapper>
        </BaseModal>,
        document.body
    );
}); 